// extracted by mini-css-extract-plugin
export default {"room":"PeZOBejMCSIVD6Ck3oaZ","title":"nEBdP42Anw8dUeDSKgiv","roomActive":"OA9Hzh3Pvm_m69BusmEA","titleActive":"Sa1U93G6Bee_YoXUy_Sl"};